import React from 'react';
import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as ActionTypes from '../constants/ActionTypes';
import colorsReducer from '../reducers/theme/colors';
import buttonsReducer from '../reducers/theme/buttons';
import buttonsDataReducer from '../reducers/theme/data/buttons';
import linksDataReducer from '../reducers/theme/data/links';
import customContentReducer from '../reducers/theme/data/custom-content';
import policyUrlsReducer from '../reducers/theme/data/policy-urls';
import filterBarReducer from '../reducers/theme/filterbar';
import filterBarDataReducer from '../reducers/theme/data/filterbar';
import globalReducer from '../reducers/theme/global';
import globalDataReducer from '../reducers/theme/data/global';
import formReducer from '../reducers/theme/form';
import formDataReducer from '../reducers/theme/data/form';
import cardReducer from '../reducers/theme/card';
import cardDataReducer from '../reducers/theme/data/card';
import calendarReducer from '../reducers/theme/calendar';
import calendarDataReducer from '../reducers/theme/data/calendar';
import carouselReducer from '../reducers/theme/carousel';
import carouselDataReducer from '../reducers/theme/data/carousel';
import headerReducer from '../reducers/theme/header';
import headerDataReducer from '../reducers/theme/data/header';
import pageTitleDataReducer from '../reducers/theme/data/pageTitle';
import imagesReducer from '../reducers/theme/images';
import configurationSectionDataStore from '../reducers/manage/data/configuration';
import labelsDataStore from '../reducers/labels/labelsReducer';
import fontsReducer from '../reducers/theme/fonts';

const actions = {
    modifyThemeKey: (path, value) => ({
        type: ActionTypes.THEME_MODIFY_KEY,
        path,
        value
    }),
    setPaletteColor: (idx, panel, label, color) => {
        return {
            type: ActionTypes.THEME_COLORS_SET_COLOR,
            target: { idx: idx, panel: panel },
            value: { color: color.startsWith('#') ? color : '#' + color, label: label }
        };
    },
    setGlobalFont: (target, font) => {
        return {
            type: ActionTypes.THEME_GLOBAL_SET_THEME_FONT,
            font: font,
            layer: target
        };
    },
    setFilterBarFont: (target, font) => {
        return {
            type: ActionTypes.THEME_FILTER_BAR_SET_THEME_FONT,
            font: font,
            layer: target
        };
    },
    setFormFont: (target, font) => {
        return {
            type: ActionTypes.THEME_FORM_SET_THEME_FONT,
            font: font,
            layer: target
        };
    }
};

const themeReducer = combineReducers({
    buttons: buttonsReducer,
    card: cardReducer,
    calendar: calendarReducer,
    carousel: carouselReducer,
    global: globalReducer,
    filterBar: filterBarReducer,
    header: headerReducer,
    form: formReducer,
    images: imagesReducer,
    fonts: fontsReducer,
    fontsUsage: (previousState = {}, action) => previousState
});

const themeDataReducer = combineReducers({
    card: cardDataReducer,
    calendar: calendarDataReducer,
    carousel: carouselDataReducer,
    global: globalDataReducer,
    filterBar: filterBarDataReducer,
    header: headerDataReducer,
    page: pageTitleDataReducer,
    buttons: buttonsDataReducer,
    links: linksDataReducer,
    customContent: customContentReducer,
    policyUrls: policyUrlsReducer,
    colors: colorsReducer,
    form: formDataReducer,
    fontsUsage: (state = {}, action) => {
        return state;
    }
});

const configDataReducer = combineReducers({
    configuration: configurationSectionDataStore
});

const labelsReducer = combineReducers({
    labels: labelsDataStore
});

export { themeReducer, themeDataReducer, configDataReducer, labelsReducer, actions };



// WEBPACK FOOTER //
// ./src/store/ThemeStore.js